import React, {Component} from 'react';
import PropTypes from "prop-types";
import { Table } from 'antd';
import {uuid} from "../../utils";

/**
 * 表格选择组件，
 */
export default class SelectTable extends Component {
    static defaultProps = {
        title:'请选择',  //标题
        dataSource:[{
            key: '1',
            name: 'John Brown',
            age: 32,
            address: 'New York No. 1 Lake Park',
            tags: ['nice', 'developer'],
        },{
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
                tags: ['loser'],
            }],  //表格中显示的数据
        column:[{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: text => <a>{text}</a>,
        },{
                title: 'Age',
                dataIndex: 'age',
                key: 'age',
            }],             //展示的数据列，
        selectType:"radio",           //单选还是多选，默认单选： radio, 多选：checkbox
        getSelectedDatas:function(data){

        }
    };

    static propTypes = {
        title:PropTypes.string.isRequired,
        dataSource:PropTypes.array.isRequired,
        getSelectedDatas:PropTypes.func.isRequired,
    };

    constructor(props){
        super(props);
        this.state = {
            selectedDatas:[],  //选中的数据
        }
    }

    render(){
        let that=this;
        const rowSelection={
            type:this.props.selectType,
            onSelect:function(record, selected, selectedRows, nativeEvent){
                console.info("data"+JSON.stringify(record)+"selected"+selected+"selectedRows"+JSON.stringify(selectedRows)+"nativeEvent:"+nativeEvent);
                if(that.props.selectType==="radio"){
                    that.props.getSelectedDatas(record);
                }else{
                    that.props.getSelectedDatas(selectedRows);
                }
            }
        }
         return (
             <div id={"table"}>
                 <Table key={uuid()} scroll={true} pagination={false} columns={this.props.column}  rowSelection={rowSelection}  dataSource={this.props.dataSource} />
                 <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-divider-horizontal{margin: 2px 0px 10px 0px;}
                    #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
             </div>
         )
    }
}